export default __webpack_public_path__ + "static/media/RebaseCopyright.85b88088.svg";